import { createAsyncStateReducer } from '@essent/common';
import type { ActionReducerMap } from '@ngrx/store';

import { smartChargingApiActions } from './api';
import type { SmartChargingState } from './smart-charging.state';

export const getLicensePlateLookupReducer = createAsyncStateReducer(
  smartChargingApiActions.getLookupV1
);

export const reducers: ActionReducerMap<SmartChargingState> = {
  licensePlateLookup: getLicensePlateLookupReducer,
};
